import React from "react";
import { Header } from "../Core/Header";
import { Footer } from "../Core/Footer";
import { fetchProductCategories, fetchProductsBySubcategory, fetchSubcategoriesByCategory } from "../Services/Operations/ProductAPI";
import { useEffect } from "react";
import { useState } from "react";
import ProductCard from "../Core/ProductCard";
import CategoryProductCard from "../Core/CategoryProductCard";

const Shop = () => {

  const[categories,setCategories]=useState([])
  const[selectedCategory,setSelectedCategory]=useState(1)
  const[subcatagory,setSubcatagory]=useState([])
  const [products,setProducts]=useState([])
   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
   const[currentSub,setCurrentSub]=useState(0)


const fetchCategories=async()=>{
  try {
    const res=await fetchProductCategories()
    console.log(res);
    if(res.length!==0){
      setCategories(res)
    }
    
  } catch (error) {
    console.log(error);
    
  }
}
const fetchSubcategories=async(category)=>{
  try {
    const res= await fetchSubcategoriesByCategory(category)
    console.log(res);
    setSubcatagory(res)
    
  } catch (error) {
    console.log(error);
    
  }
}

const fetchProducts=async(id)=>{
  
   try {
    const res= await fetchProductsBySubcategory(id)
    console.log("products ",res);
   setProducts(res)
   setCurrentSub(id)
    
  } catch (error) {
    console.log(error);
    
  }

}


 const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    
    // Clean up on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

useEffect(() => {
  fetchCategories()
  fetchSubcategories(selectedCategory)
  fetchProducts(1)
}, [])



  return (
    <div>
      
      <Header/>
     
      <div
        className="modal fade"
        id="searchModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content rounded-0">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Search by keyword
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body d-flex align-items-center">
              <div className="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  className="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span id="search-icon-1" className="input-group-text p-3">
                  <i className="fa fa-search" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal Search End */}
      {/* Single Page Header start */}
      <div className="container-fluid page-header py-10"
      style={{height:"200px"}}
      >
        <h1 className="text-center text-white display-6">Shop</h1>
        <ol className="Earscrumb justify-content-center mb-0">
          <li className="Earscrumb-item">
            <a href="#">Home</a>
          </li>
          <li className="Earscrumb-item">
            <a href="#">Pages</a>
          </li>
          <li className="Earscrumb-item active text-white">Shop</li>
        </ol>
      </div>
      {/* Single Page Header End */}
      {/* Ear Shop Start*/}
      <div className="container-fluid fruite py-5">
        <div className="container py-5">
          <h1 className="mb-4">Fresh Ear shop</h1>
          <div className="row g-4">
            <div className="col-lg-12">
              <div className="row g-4">
               
                <div className="col-6" />
                <div className="col-xl-3">
                  {/* <div className="bg-light ps-3 py-3 rounded d-flex justify-content-between mb-4">
                    <label htmlFor="Ear">Default Sorting:</label>
                    <select
                      id="Ear"
                      name="fruitlist"
                      className="border-0 form-select-sm bg-light me-3"
                      form="fruitform"
                    >
                      <option value="volvo">Nothing</option>
                      <option value="saab">Popularity</option>
                      <option value="opel">Organic</option>
                      <option value="audi">Fantastic</option>
                    </select>
                  </div> */}
                </div>
              </div>
              <div className="row g-4">
                <div className="col-lg-3">
                  <div className="row g-4">
                    <div className="col-lg-12">
                    
                    <div className="">
                      <div className={`mb-3 w-fit  ${window.innerWidth<568?"max-h-[50vh] overflow-y-auto":"max-h-fit"}`}
                      style={{borderLeft:isMobile?"":"4.5px solid red"}}
                      >
                        <h4>Categories</h4>
                        <ul className="list-unstyled fruite-categorie"
                        style={{display:"flex",width:isMobile?"100vw":"100%",maxWidth:"100vw",overflow:"auto",flexDirection:isMobile?"row":"column",paddingLeft:"10px",paddingRight:"10px"}}
                        >
                         {
                          categories.map((cat,index)=>(
                            <li key={cat.id} onClick={()=>{
                              fetchSubcategories(cat.id)
                              setSelectedCategory(cat.id)}}>
                          { isMobile? <div className={`flex items-center justify-between  hover:text-orange-400 fruite-name  cursor-pointer hover:bg-gray-200 rounded-lg px-2 ${selectedCategory===cat.id?"text-yellow-600 bg-gray-100":"text-black"} border shadow border-gray-200 my-1 w-[160px]`}>
                              
                               <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:"5px"}}>
                                <img src="/Assets/img/arrow.png" className="w-3"/>
                              <p style={{textAlign:"left",fontSize:"12px"}}> {cat.productCategoryName}</p></div>
                              
                              
                            </div>
                              :
                             <div className={`flex items-center justify-between  hover:text-orange-400 fruite-name  cursor-pointer hover:bg-gray-200 rounded-lg px-2 ${selectedCategory===cat.id?"text-yellow-600 bg-gray-100":"text-black"} border shadow border-gray-200 my-1 `}>
                              
                               <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:"10px"}}>
                                <img src="/Assets/img/arrow.png" className="w-6"/>
                              <p style={{textAlign:"left"}}> {cat.productCategoryName}</p></div>
                              
                             
                            </div>}
                          </li>
                          ))
                         }
                         
                            
                        </ul>
                      </div>

                      {isMobile&&  <div className="flex flex-col justify-center max-w-[100vw]   items-center mb-4">
            
                    {subcatagory.length !== 0 ?
                    <div className={`flex  items-center ${window.innerWidth<568?"max-h-[50vh] overflow-y-auto":"max-h-fit"} cursor-pointer `}>
                      {
                        subcatagory.map((subcat,index)=>(
                          <div onClick={()=>fetchProducts(subcat.id)}
                          style={{borderBottom:subcat.id===currentSub?"1px solid black":"1px solid gray",
                            backgroundColor:subcat.id===currentSub?"#b4b4b4ff":"",
                          }}
                          className="flex flex-col gap-[0px] items-center justify-center px-2 mx-3 h-fit min-w-fit rounded-lg ">
                           <p   className="text-black bg-clip-text bg-gradient-to-r from-red-500 to-blue-500 text-[12px] font-bold"> {subcat.productSubCategoryName}</p>
                       
                          </div>
                        ))
                      }
                    </div>:
                    <div className="alert alert-warning" role="alert">
                      No subcategories available for this category.
                      </div>
                    }
                     </div>}
                  </div>


                    </div>
                    {/* <div className="col-lg-12">
                      <div className="mb-3">
                        <h4 className="mb-2">Price</h4>
                        <input
                          type="range"
                          className="form-range w-100"
                          id="rangeInput"
                          name="rangeInput"
                          min={0}
                          max={500}
                          defaultValue={0}
                          oninput="amount.value=rangeInput.value"
                        />
                        <output
                          id="amount"
                          name="amount"
                          min-velue={0}
                          max-value={500}
                          htmlFor="rangeInput"
                        >
                          0
                        </output>
                      </div>
                    </div> */}
                    {/* products lists for mobile view */}
                    {isMobile&&<div className="flex flex-col justify-center">
                      <div className="flex " style={{maxWidth:"90vw",overflow:"auto",flexWrap:isMobile?"wrap":"nowrap"}}>
                    {products.length !== 0 ?
                    products.map((item,index)=>(
                     <CategoryProductCard img={item.productImage} price={item.salePrice} 
                                              id={item.id}
                                            description={" "}
                                             name={item.productName} stock={item.stock}/>
                    ))

                    :" No products are available for this category"
                    }</div>
                    <div className="col-12">
                      
                    </div>
                  </div>}


                    {/* <div className="col-lg-12">
                      <div className="mb-3">
                        <h4>Additional</h4>
                        <div className="mb-2">
                          <input
                            type="radio"
                            className="me-2"
                            id="Categories-1"
                            name="Categories-1"
                            defaultValue="Beverages"
                          />
                          <label htmlFor="Categories-1"> Organic</label>
                        </div>
                        <div className="mb-2">
                          <input
                            type="radio"
                            className="me-2"
                            id="Categories-2"
                            name="Categories-1"
                            defaultValue="Beverages"
                          />
                          <label htmlFor="Categories-2"> Fresh</label>
                        </div>
                        <div className="mb-2">
                          <input
                            type="radio"
                            className="me-2"
                            id="Categories-3"
                            name="Categories-1"
                            defaultValue="Beverages"
                          />
                          <label htmlFor="Categories-3"> Sales</label>
                        </div>
                        <div className="mb-2">
                          <input
                            type="radio"
                            className="me-2"
                            id="Categories-4"
                            name="Categories-1"
                            defaultValue="Beverages"
                          />
                          <label htmlFor="Categories-4"> Discount</label>
                        </div>
                        <div className="mb-2">
                          <input
                            type="radio"
                            className="me-2"
                            id="Categories-5"
                            name="Categories-1"
                            defaultValue="Beverages"
                          />
                          <label htmlFor="Categories-5"> Expired</label>
                        </div>
                      </div>
                    </div> */}
                    <div className="col-lg-12">
                      <h4 className="mb-3">Featured products</h4>
                   
                     
                     
                    
                    </div>
                    <div className="col-lg-12">
                      <div className="position-relative">
                        <img
                          src="Assets/img/earbanner.jpg"
                          className="img-fluid w-100 rounded"
                          alt
                        />
                        <div
                          className="position-absolute"
                          style={{
                            top: "50%",
                            right: 10,
                            transform: "translateY(-50%)",
                          }}
                        >
                          <h3 className="text-secondary fw-bold">
                            Fresh <br /> Ear <br /> Banner
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

               {!isMobile&& <div className="col-lg-9">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    {subcatagory.length !== 0 ?
                    <div className="flex items-center  cursor-pointer w-screen overflow-auto">
                      {
                        subcatagory.map((subcat,index)=>(
                          <div onClick={()=>fetchProducts(subcat.id)}
                          style={{borderBottom:subcat.id===currentSub?"1px solid black":"1px solid gray",
                            backgroundColor:subcat.id===currentSub?"#b4b4b4ff":"",
                          }}
                          className="flex  gap-[10px] items-center justify-center px-2 mx-3 rounded-lg  hover:bg-gray-300">
                           <p className="text-black bg-clip-text bg-transparent text-xl font-bold">
                             {subcat.productSubCategoryName}</p>
                          
                          </div>
                        ))
                      }
                    </div>:
                    <div className="alert alert-warning" role="alert">
                      No subcategories available for this category.
                      </div>
                    }
                  </div>
                  <div className="row g-4"
                  style={{display:"flex",flexWrap:"wrap"}}
                  >
                    {products.length !== 0 ?
                    products.map((item,index)=>(
                     <CategoryProductCard img={item.productImage} price={item.salePrice} 
                                              id={item.id}
                                            description={" "}
                                             name={item.productName} stock={item.stock}/>
                    ))

                    :" no products are available for this category"
                    }
                    {/* <div className="col-12">
                      <div className="pagination d-flex justify-content-center mt-5">
                        <a href="#" className="rounded">
                          «
                        </a>
                        <a href="#" className="active rounded">
                          1
                        </a>
                        <a href="#" className="rounded">
                          2
                        </a>
                        <a href="#" className="rounded">
                          3
                        </a>
                        <a href="#" className="rounded">
                          4
                        </a>
                        <a href="#" className="rounded">
                          5
                        </a>
                        <a href="#" className="rounded">
                          6
                        </a>
                        <a href="#" className="rounded">
                          »
                        </a>
                      </div>
                    </div> */}
                  </div>
                </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer/>

    </div>
  );
};

export default Shop;
